import { NavLink } from "react-router";

import Avatar from "@/design/components/Avatar";
import HeaderCard from "@/design/components/HeaderCard";
import Valkyrie, { viArrowLeft, viCircleXmark, viXmark } from "@sippy-platform/valkyrie";

import { IconButton, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";

export default function NotFoundPage({ message }) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <>
      <HeaderCard
        avatar={
          !matches && (
            <IconButton variant="avatar" component={NavLink} to="..">
              <Valkyrie icon={viArrowLeft} />
              <Avatar icon={viCircleXmark} />
            </IconButton>
          )
        }
        title={message ?? "Page not found"}
      />
      <Stack sx={{ textAlign: "center", pt: 8 }}>
        <Typography variant="h1" color="error">
          <Valkyrie icon={viXmark} />
        </Typography>
        <Typography variant="h5">{message ?? "Page not found"}</Typography>
      </Stack>
    </>
  );
}
